
import { ACTION_APP } from '@/store/actions'
import { DatetimeUtils } from '@/utils/datetime'
import { ITableColumn, TableUtils } from '@/utils/table'
import { first, get, orderBy, sumBy } from 'lodash'
import { Options, mixins } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import BaseTableComponent from './components/BaseTableComponent.vue'
import TableMixin from './mixins/TableMixin.vue'

@Options({
  name: 'UserTable',
  components: {
    BaseTableComponent,
  },
})
export default class UserTable extends mixins(TableMixin) {
  private userTableData: any[] = []

  @Watch('dateRange', { deep: true, immediate: true })
  onDateRangeChange(newVal: any) {
    this.fetchData()
  }

  async fetchData() {
    try {
      const resp = await this.$store.dispatch(ACTION_APP.OVERVIEW_DETAIL, {
        app_id: this.appId,
        is_test_mode: false,
        date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
        date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
      })

      this.processData(get(resp, 'users_statistic', []))
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  private processData(data: any) {
    this.userTableData = data
  }

  get columns(): ITableColumn[] {
    return [
      ...this.baseColumns,
      {
        name: 'total_active_users',
        label: this.$t('label.active_users'),
        field: 'total_active_users',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'new_users',
        label: this.$t('label.add_unblock'),
        field: 'new_users',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'blocked_users',
        label: this.$t('label.block'),
        field: 'blocked_users',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'block_rate',
        label: this.$t('label.block_rate'),
        field: (row: any) => TableUtils.calculatePercent(row.blocked_users, row.total_active_users),
        align: 'right',
        format: TableUtils.formatPercent,
      },
      {
        name: 'message_target_count',
        label: this.$t('label.delivery_count'),
        field: 'message_target_count',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'message_success_count',
        label: this.$t('label.success_count'),
        field: 'message_success_count',
        align: 'right',
        format: TableUtils.formatNumber,
      },
    ]
  }

  protected calculateSummary(): Record<string, number> {
    const latestRow = first(orderBy(this.userTableData, ['date'], ['desc'])) || {}

    const summary = {
      total_active_users: get(latestRow, 'total_active_users', 0),
      new_users: sumBy(this.userTableData, 'new_users'),
      blocked_users: sumBy(this.userTableData, 'blocked_users'),
      message_target_count: sumBy(this.userTableData, 'message_target_count'),
      message_success_count: sumBy(this.userTableData, 'message_success_count'),
    }

    const block_rate = TableUtils.calculatePercent(summary.blocked_users, summary.total_active_users)

    return {
      ...summary,
      block_rate,
    }
  }
}
